function initializeHeroPlaylist() {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const marquee = entry.target.querySelector('.hero-playlist-track');
        if (marquee) {
          if (entry.isIntersecting) {
            marquee.style.animationPlayState = 'running';
          } else {
            marquee.style.animationPlayState = 'paused';
          }
        }
      });
    }, {
      threshold: 0.1
    });

    document.querySelectorAll('.hero-playlist').forEach(section => {
      observer.observe(section);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initializeHeroPlaylist();
});

document.addEventListener('shopify:section:load', () => {
  initializeHeroPlaylist();
});